import { Button, Checkbox, Divider, Space } from '@oscar/theme';
import { isEmpty } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import './style.scss';

const CheckboxGroup = Checkbox.Group;

type Item = {
  value: string | number;
  label: string;
};

type OptionGroupProps = {
  data: Item[];
  title?: any;
  visible?: boolean;
  confirm?: () => void;
  noStyle: boolean;
  groupClassName?: string;
  [name: string]: any;
};

function OptionGroup(props: OptionGroupProps) {
  const {
    setSelectedKeys,
    selectedKeys,
    confirm,
    visible,
    data = [],
    noStyle,
    groupClassName,
    title,
  } = props;
  const [indeterminate, setIndeterminate] = React.useState(false);
  const [checkAll, setCheckAll] = React.useState(false);

  useEffect(() => {
    if (!visible) {
      confirm?.();
    }
  }, [visible]);

  const currentSelected = useMemo(() => {
    return typeof selectedKeys === 'string'
      ? selectedKeys?.split?.(',').filter((item) => item)
      : selectedKeys || [];
  }, [selectedKeys]);

  const onChange = (list: any) => {
    setIndeterminate(!!list.length && list.length < data.length);
    setCheckAll(list.length === data.length);
    setSelectedKeys(list.join(','));
  };

  useEffect(() => {
    if (currentSelected?.length === data.length) {
      handleSelectAll();
    } else if (isEmpty(currentSelected)) {
      handleClearFilter();
    }
  }, [currentSelected]);

  const onCheckAllChange = (e: any) => {
    if (e.target.checked) {
      handleSelectAll();
    } else {
      handleClearFilter();
    }
  };

  const handleSelectAll = () => {
    setSelectedKeys(data.map((item) => item.value).join(','));
    setIndeterminate(false);
    setCheckAll(true);
  };

  const handleClearFilter = () => {
    setIndeterminate(false);
    setCheckAll(false);
    setSelectedKeys('');
  };

  return (
    <div className={!noStyle ? 'ant-table-column-filter-status' : ''}>
      <Space>
        {title}
        <Checkbox
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
          checked={checkAll}
        >
          Select all
        </Checkbox>
        <CheckboxGroup
          options={data.map((item) => ({
            value: item.value.toString(),
            label: item.label,
          }))}
          value={selectedKeys?.split?.(',') || selectedKeys}
          onChange={onChange}
          className={groupClassName}
        />
      </Space>
      {confirm && (
        <>
          <Divider className="margin-divider" />
          <Button type="link" size="small" onClick={handleClearFilter}>
            Clear Filter
          </Button>
        </>
      )}
    </div>
  );
}

export default OptionGroup;
